import React from 'react'

const SIZE_CLASS = {
  card: 'w-12 md:w-14',
  fiche: 'w-16 md:w-[76px]',
  line: 'w-11 md:w-12',
}

/**
 * Badge PRO officiel — PNG original, crop visuel CSS de la zone utile.
 * Identique au badge Website (canvas 2172×724, bbox 640×286).
 */
export default function ProBadge({ size = 'card', className = '' }) {
  const widthClass = SIZE_CLASS[size] || SIZE_CLASS.card

  return (
    <span
      className={`relative block overflow-hidden ${widthClass} ${className}`.trim()}
      style={{ aspectRatio: '640 / 286' }}
    >
      <img
        src="/assets/badge-pro-clickorico.png"
        alt="PRO"
        className="pointer-events-none absolute h-auto max-w-none"
        style={{
          width: '339.375%',
          left: '-119.53125%',
          top: '-76.573426573%',
        }}
        draggable={false}
      />
    </span>
  )
}
